/**
 * Retrieval defaults for a DocChat case. The site check uses the case site,
 * not a plant hardcoded here.
 */
export function emptyDocChatExpectations(siteId: string) {
  return {
    retrieval: {
      tool_calls: {
        must_include: ['search_documents_and_sensors', 'cite_references'],
        must_not_include: [
          'get_time_series_data',
          'analyze_time_series_features',
          'search_pi_tags',
        ],
        max_total_calls: 30,
        arg_checks: [
          {
            tool_name: 'search_documents_and_sensors',
            arg_name: 'site_id',
            expected_value: siteId,
          },
        ],
      },
      references: {
        documents: {
          must_include_ids: [] as string[],
          acceptable_ids: [] as string[],
          must_not_include_ids: [] as string[],
          min_count: 0,
        },
        datastreams: {
          must_include_names: [] as string[],
          must_not_include_names: [] as string[],
          min_count: 0,
        },
      },
      sources: {
        must_retrieve: [] as Array<{ document_id: string; pages: number[] }>,
      },
    },
    answer: {
      must_state: [] as string[],
      must_not_state: [] as string[],
      must_not_mention: [] as string[],
    },
    expected_runtime_seconds: 60,
  }
}
